import { apiFetch } from "./client.js";

export interface SendResult {
  ok: boolean;
  sent: boolean;
}

export function sendKidStatement(kidId: string): Promise<SendResult> {
  return apiFetch<SendResult>(`/api/kids/${encodeURIComponent(kidId)}/send-statement`, {
    method: "POST",
  });
}

export function sendFamilySummary(): Promise<SendResult> {
  return apiFetch<SendResult>("/api/send-family-summary", { method: "POST" });
}
